import PageMeta from '@/components/PageMeta';
import { TERMS as DOC } from '@/content/legal';

export default function Terms() {
  return (
    <article>
      <PageMeta
        title="Terms and conditions (draft)"
        description="Draft Valanti Labs terms and conditions, subject to legal review before publication."
      />
      <div className="vl-container py-16 lg:py-24 max-w-3xl">
        <p className="mono-label text-vl-violet">{DOC.kicker}</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mt-5 text-vl-ink">
          {DOC.title}
        </h1>
        <p className="mt-5 mono-label text-vl-violet/90 bg-vl-violet/10 inline-block px-3 py-1.5 rounded-full">
          {DOC.draftLabel}
        </p>
        <p className="mt-8 text-lg text-vl-ink/70 leading-relaxed">{DOC.intro}</p>

        <div className="mt-14 space-y-10">
          {DOC.sections.map((s, i) => (
            <section key={s.t}>
              <h2 className="font-serif-display text-2xl text-vl-ink">
                {(i + 1).toString().padStart(2, '0')}. {s.t}
              </h2>
              <p className="mt-3 text-vl-ink/75 leading-relaxed">{s.b}</p>
            </section>
          ))}
        </div>

        <p className="mt-16 text-xs text-vl-ink/55 leading-relaxed border-t hairline pt-6">{DOC.lastUpdated}</p>
      </div>
    </article>
  );
}
